import React from 'react';
import { EnrollmentCourseStructureCardComponent } from "./enrollment-course-structure-card.component";
import { EnrollmentCourseStructureTrainingProgramComponent } from "./enrollment-course-structure-training-program.component";
export const EnrollmentCourseStructure = props => {
  const {
    CourseCard = EnrollmentCourseStructureCardComponent,
    data
  } = props;
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "course-structure"
  }, data.map((x, i) => /*#__PURE__*/React.createElement(EnrollmentCourseStructureTrainingProgramComponent, {
    key: i,
    CourseCard: CourseCard,
    enrollmentTrainingProgram: x
  }))));
};